import '@fortawesome/fontawesome-pro/css/all.min.css'
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from './i18n'

Vue.use(Vuetify)

const theme = {
  primary: '#0057c1',
  secondary: '#333333',
  accent1: '#1d96c0',
  accent2: '#603f99',
  accent3: '#3e985c',
  accent4: '#f29a25',
  error: '#d81632',
  warning: '#f29a25',
  info: '#757575',
  success: '#3e985c',
  textlt: '#212121',
  background: '#FFFFFF'
}

export default new Vuetify({
  lang: {
    t: (key, ...params): string => {
      return i18n.t(key, params) as string
    }
  },
  breakpoint: {
    thresholds: {
      xs: 576,
      sm: 768,
      md: 992,
      lg: 1200
    },
    scrollBarWidth: 16,
    mobileBreakpoint: 768
  },
  theme: {
    themes: {
      dark: theme,
      light: theme
    }
  },
  icons: {
    iconfont: 'fa' || 'mdi',
    values: {
      dropdown: 'mdi-chevron-down'
    }
  }
})
